import { render, staticRenderFns } from "./LiquidationView.vue?vue&type=template&id=d2545d04&scoped=true"
import script from "./LiquidationView.vue?vue&type=script&lang=js"
export * from "./LiquidationView.vue?vue&type=script&lang=js"
import style0 from "./LiquidationView.vue?vue&type=style&index=0&id=d2545d04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2545d04",
  null
  
)

export default component.exports